import { SwitchTheme as SwitchDefaultTheme } from "@acin.reactjs/acin-ui/switch";
import { DefaultTheme } from "styled-components";

const SwitchTheme = (theme: DefaultTheme): SwitchDefaultTheme => ({
  checked: {
    toggle: {
      backgroundColor: theme.palette.secondary[600],
    },
    track: {
      border: `1px solid ${theme.palette.secondary[600]}`,
    },
    focused: {
      toggle: {
        backgroundColor: theme.palette.secondary[600],
      },
      track: {
        border: `1px solid ${theme.palette.secondary[600]}`,
      },
    },
    hover: {
      toggle: {
        backgroundColor: theme.palette.secondary[600],
      },
      track: {
        border: `1px solid ${theme.palette.secondary[600]}`,
      },
    },
  },
});

export default SwitchTheme;
